import React from 'react';
import Modal from '../ui/Modal';
import RetailerCard from '../product/RetailerCard';

const BuyNowModal = ({ isOpen, product, onClose }) => {
  if (!product) {
    return null;
  }

  const encodedMessage = encodeURIComponent('Hi, I want to buy this YANX product');
  const whatsappNumber = '919056800633';
  const productSlug = encodeURIComponent(product.name.toLowerCase().replace(/\s+/g, '-'));

  const retailerOptions = [
    {
      name: 'Flipkart',
      platform: 'flipkart',
      href: `https://www.flipkart.com/search?q=${productSlug}`
    },
    {
      name: 'Amazon',
      platform: 'amazon',
      href: `https://www.amazon.in/s?k=${productSlug}`
    },
    {
      name: 'Myntra',
      platform: 'myntra',
      href: `https://www.myntra.com/${productSlug}`
    },
    {
      name: 'WhatsApp',
      platform: 'whatsapp',
      href: `https://wa.me/${whatsappNumber}?text=${encodedMessage}`
    }
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Choose where to buy" className="buy-flow-modal">
      <div className="buy-flow-content">
        <header className="buy-flow-header">
          <h2 className="buy-flow-title">Choose where to buy</h2>
          <p className="buy-flow-subtitle">{product.name}</p>
        </header>

        <div className="retailer-grid">
          {retailerOptions.map((option) => (
            <RetailerCard
              key={option.platform}
              name={option.name}
              href={option.href}
              platform={option.platform}
            />
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default BuyNowModal;
